// import React from "react";

// import xls from "assets/images/fileImage/xls.svg";
// import pdf from "assets/images/fileImage/pdf.svg";
// import docs from "assets/images/fileImage/docs.svg";
// import deleteIcon from "assets/images/fileImage/delete.svg";
// import "./uploadFileContent.scss";

// const fileNameData = [
//   {
//     fileName: "Workforce Budget Analysis.xls",
//     fileImage: xls,
//     fileSize: "3 MB"
//   },
//   {
//     fileName: "Team Performance Review Q1.docx",
//     fileImage: docs,
//     fileSize: "1.2 GB"
//   },
//   { fileName: "Q1 Team Review.xls", fileImage: xls, fileSize: "1.2 GB" },
//   {
//     fileName: "Team Performance Review Q2.docx",
//     fileImage: docs,
//     fileSize: "1.2 GB"
//   },
//   {
//     fileName: "Team Performance Review Q3.pdf",
//     fileImage: pdf,
//     fileSize: "1.1 GB"
//   },
//   { fileName: "Q1 Team Review.xls", fileImage: xls, fileSize: "1.2 GB" },
//   {
//     fileName: "Team Performance Review Q2.docx",
//     fileImage: docs,
//     fileSize: "1.2 GB"
//   },
//   {
//     fileName: "Team Performance Review Q3.pdf",
//     fileImage: pdf,
//     fileSize: "1.1 GB"
//   },
//   { fileName: "Q1 Team Review.xls", fileImage: xls, fileSize: "1.2 GB" },
//   {
//     fileName: "Team Performance Review Q2.docx",
//     fileImage: docs,
//     fileSize: "1.2 GB"
//   },
//   {
//     fileName: "Team Performance Review Q3.pdf",
//     fileImage: pdf,
//     fileSize: "1.1 GB"
//   }
// ];

// const UploadFileContent = ({ files, setFilesList }) => {
//   return (
//     <section className="container uploadFileContainer">
//       <div className="uploadFileHeader">
//         <h2 className="confirmHeading">
//           Are you sure you want to upload these files?
//         </h2>
//         <p className="notifyUpload">
//           This will upload all files from the device
//         </p>
//       </div>
//       <div className="fileNameContainer">
//         {fileNameData.map((item, index) => (
//           <div className="outsideFileNameContainer" key={index}>
//             <div className="fileNames">
//               <div className="fileNameContainer">
//                 <img src={item.fileImage} alt="" />
//                 <p className="fileName">{item.fileName}</p>
//               </div>
//               <div className="fileSizeContainer">
//                 <span className="fileSize">{item.fileSize}</span>
//                 <img src={deleteIcon} alt="Delete" />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default UploadFileContent;

import React, { useEffect } from "react";
import xls from "assets/images/fileImage/xls.svg";
import pdf from "assets/images/fileImage/pdf.svg";
import docs from "assets/images/fileImage/docs.svg";
import deleteIcon from "assets/images/fileImage/delete.svg";
import jpf from "assets/images/fileImage/jpg.svg";
import folder from "assets/images/fileImage/folder.svg";
import zip from "assets/images/homepage/ySafe/zip.svg";
import commonIcon from "assets/images/homepage/ySafe/commonFile.svg";

import "./uploadFileContent.scss";
import { formatFileSize } from "constants/Common/formatFileSize";

// Function to get file icon based on extension
export const getFileIcon = (fileName) => {
  const extension = fileName?.split(".").pop().toLowerCase();
  switch (extension) {
    case "xls":
    case "xlsx":
      return xls;
    case "pdf":
      return pdf;
    case "doc":
    case "docx":
      return docs;
    case "jpg":
    case "png":
    case "jpeg":
      return jpf;
    case "zip":
      return zip;
    default:
      return commonIcon;
  }
};

// const UploadFileContent = ({ files, setFilesList }) => {
//   // Function to delete file from the list
//   const handleDelete = (fileName) => {
//     const updatedFiles = files.filter((file) => file.name !== fileName);
//     setFilesList(updatedFiles);
//   };

//   return (
//     <section className="container uploadFileContainer">
//       <div className="uploadFileHeader">
//         <h2 className="confirmHeading">
//           Are you sure you want to upload these files?
//         </h2>
//         <p className="notifyUpload">
//           This will upload all files from the device
//         </p>
//       </div>
//       <div className="fileNameContainer">
//         {files.map((file, index) => (
//           <div className="outsideFileNameContainer" key={index}>
//             <div className="fileNames">
//               <div className="fileNameContainer">
//                 <img src={getFileIcon(file.name)} alt="" />
//                 <p className="fileName">{file.name}</p>
//               </div>
//               <div className="fileSizeContainer">
//                 <span className="fileSize">
//                   {(file.size / 1024 / 1024).toFixed(2)} MB
//                 </span>
//                 <img
//                   src={deleteIcon}
//                   alt="Delete"
//                   onClick={() => handleDelete(file.name)}
//                   style={{ cursor: "pointer" }}
//                 />
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

const getTruncatedFileName = (name, maxLength = 60) => {
  const lastDotIndex = name.lastIndexOf(".");
  if (lastDotIndex === -1)
    return name.length > maxLength ? name.slice(0, maxLength) + "..." : name; // For folders or files without extensions

  const fileName = name.substring(0, lastDotIndex);
  const extension = name.substring(lastDotIndex);

  if (fileName.length > maxLength) {
    return fileName.slice(0, maxLength) + "..." + extension;
  }

  return name; // Return full name if within limit
};

const UploadFileContent = ({
  files,
  setFilesList,
  setIsDropDownVisible,
  setSelectedFile
}) => {
  const isSameFile = (a, b) =>
    a === b ||
    (
      a?.name === b?.name &&
      a?.size === b?.size &&
      a?.lastModified === b?.lastModified
    );

  const handleDelete = (fileToDelete) => {
    const nextFiles = files.filter((file) => !isSameFile(file, fileToDelete));
    setFilesList(nextFiles);
    if (typeof setSelectedFile === "function") {
      setSelectedFile((prev) => prev.filter((file) => !isSameFile(file, fileToDelete)));
    }
  };

  //   const formatFileSize = (size) => {
  //     console.log(size, "size");

  //     if (size < 1024) {
  //       return `${size} B`; // Bytes
  //     } else if (size < 1024 * 1024) {
  //       return `${(size / 1024).toFixed(2)} KB`; // Kilobytes
  //     } else if (size < 1024 * 1024 * 1024) {
  //       return `${(size / (1024 * 1024)).toFixed(2)} MB`; // Megabytes
  //     } else {
  //       return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`; // Gigabytes
  //     }
  //   };

  const close = () => {
    setIsDropDownVisible(false);
  };
  useEffect(() => {
    close();
  }, []);
  return (
    <section className="container uploadFileContainer">
      <div className="uploadFileHeader">
        <h2 className="confirmHeading">
          {files.length === 1 
          ? "Are you sure you want to upload this file?"
           : "Are you sure you want to upload these files?"
           }
        </h2>
        {/* <p className="notifyUpload">
          This will upload all the selected files
        </p> */}
      </div>
      <div className="fileNameContainer">
        {files.map((file, index) => (
          <div className="outsideFileNameContainer" key={index}>
            <div className="fileNames">
              <div className="fileNameContainers">
                {/* {file.type === "folder" ? (
                  <>
                    <img src={folder} alt="Folder Icon" />
                    <p className="fileName">
                      {getTruncatedFileName(file.name)}
                      <span className="fileSizeMobile">
                        {formatFileSize(file.size)}
                      </span>
                    </p>
                  </>
                ) : (
                  <>
                    <img src={getFileIcon(file.name)} alt="File Icon" />
                    <p className="fileName">
                      {getTruncatedFileName(file.name)}
                      <span className="fileSizeMobile">
                        {formatFileSize(file.size)}
                      </span>
                    </p>
                  </>
                )} */}
                <>
                  <img
                    src={
                      file.type === "folder" ? folder : getFileIcon(file.name)
                    }
                    alt="File Icon"
                  />
                  <p className="fileName">
                    <span className="fileTitle">
                      {getTruncatedFileName(file.name)}
                    </span>
                    <span className="fileSizeMobile">
                      {formatFileSize(file.size)}
                    </span>
                  </p>
                </>
              </div>
              <div className="fileSizeContainer">
                <span className="fileSize">{formatFileSize(file.size)}</span>
                <img
                  src={deleteIcon}
                  alt="Delete"
                  onClick={() => handleDelete(file)}
                  style={{ cursor: "pointer" }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default UploadFileContent;
